import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { accountDiscoveryTypes } from 'app-components/flux/account-discovery';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

export const AddPaymentProviderAction = createAction(rootUiActions.createDialog.toString(), (businessId: string) =>
  rootUiTypes.mkRootUiData({
    type: accountDiscoveryTypes.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
    props: ImmutableMap(
      accountDiscoveryTypes.mkAccountDiscoveryDialogProps({
        mode: 'ADD-PAYMENT-PROVIDER',
        businessId,
      }),
    ),
  }),
);
